import dayjs from 'dayjs';

import { getDayStartTimestamp } from '@pages/Users/ActionsHistoryPage/utils/getDayStartTimestamp';

export const defaultSearchFilters = {
  UserIds: null,
  Keys: null,
  DateStart: getDayStartTimestamp(dayjs(new Date().toISOString())),
  DateEnd: new Date().toISOString(),
  ItemsPerPage: 20,
  IsOnlyImportant: false,
};
